module.exports = __webpack_public_path__ + "static/media/Brandon_bld.fa11c3ca.otf";